import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-conheca-nosso-trabalho',
  templateUrl: './conheca-nosso-trabalho.component.html',
  styleUrls: ['./conheca-nosso-trabalho.component.scss'],
})
export class ConhecaNossoTrabalhoComponent implements OnInit {
  cardList: Array<any>;

  constructor(private router: Router) {
    this.cardList = [
      {
        titulo: 'O que é um dado pessoal?',
        descricao:
          'É qualquer informação relacionada a uma pessoa natural identificada ou identificável. Isso significa que um dado é considerado pessoal quando ele permite a identificação, direta ou indireta, do indivíduo por trás do dado, como, por exemplo: nome, número de inscrição no CPF, e-mail, entre outros.',
        link: '#',
        id: 'card-1',
      },
      {
        titulo: 'O que não é um dado pessoal?',
        descricao:
          'Um dado não tem caráter pessoal quando não for capaz de identificar uma pessoa natural. Por exemplo, dados utilizados em modelos estatísticos para determinar a probabilidade de uma área ter pessoas que podem visitar uma loja de moda ou supermercado, a partir dos quais não é possível identificar a que pessoas se referem.',
        link: '#',
        id: 'card-2',
      },
    ];
  }
  ngOnInit(): void {}

  exibirPaginaRelSintetico() {
    this.router.navigate(['/relatorio-sintetico']);
  }
}
